import React, { useState, useRef, useEffect } from "react";
import "../../Style/Journal.css";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Modal } from "@mui/material";
import axios from "axios";
import { path_url } from "../../Config/config";
import "react-toastify/dist/ReactToastify.css";
import { data } from "jquery";
const JournalConfiguration = () => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [data, setData] = useState([]);
  const [showAllConfigurations, setShowAllConfigurations] = useState(false);
  const [
    useCrDrInsteadToDuringVoucherEntry,
    setUseCrDrInsteadToDuringVoucherEntry,
  ] = useState(false);
  const [
    preAllocatePaymentJournalVouchers,
    setPreAllocatePaymentJournalVouchers,
  ] = useState(false);
  const [
    useDefaultBilllWiseDetailsForBilllAllocation,
    setUseDefaultBilllWiseDetailsForBilllAllocation,
  ] = useState(false);
  const [showInventoryDetails, setShowInventoryDetails] = useState(false);
  const [
    showBillWiseDetailsInMultipleLines,
    setShowBillWiseDetailsInMultipleLines,
  ] = useState(false);
  const [showListOfBillsForSelection, setShowListOfBillsForSelection] =
    useState(false);
  const [showFinalBalancesForEachBill, setShowFinalBalancesForEachBill] =
    useState(false);
  const [provideReferenceNoAndDate, setProvideReferenceNoAndDate] =
    useState(false);
  const [warnOnNegativeCashBalance, setWarnOnNegativeCashBalance] =
    useState(false);
  const [
    skipDateFieldDuringVoucherCreation,
    setSkipDateFieldDuringVoucherCreation,
  ] = useState(false);
  const [showCurrentBalanceOfLedgers, setShowCurrentBalanceOfLedgers] =
    useState(false);
  const [showBalancesAsVocherDate, setShowBalancesAsVocherDate] =
    useState(false);
  const [shoeFinalLedgerBalance, setShoeFinalLedgerBalance] = useState(false);
  const [enableStripeView, setEnableStripeView] = useState(false);
  const [useDefaultBankAllocations, setUseDefaultBankAllocations] =
    useState(false);
  const [useAutoChequeNumbering, setUseAutoChequeNumbering] = useState(false);
  const [selectChequeRange, setSelectChequeRange] = useState(false);
  const [printChequeAfterSavingVoucher, setPrintChequeAfterSavingVoucher] =
    useState(false);
  const [showChequeDetailsBeforePrinting, setShowChequeDetailsBeforePrinting] =
    useState(false);
  const [showBankAlloocationDetails, setShowBankAlloocationDetails] =
    useState(false);
  const [
    removeBankDateWhileAlteringReconciledVoucher,
    setRemoveBankDateWhileAlteringReconciledVoucher,
  ] = useState(false);
  const [providePartyDetailForGST, setProvidePartyDetailForGST] =
    useState(false);
  const [modifyGSTHSNSACRElatedDetails, setModifyGSTHSNSACRElatedDetails] =
    useState(false);
  const navigate = useNavigate();
  const handleClose = () => {
    navigate("/crm-dashboard");
  };

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        const valid = localStorage.getItem("userId");

        if (!token || !valid) {
          toast.error("Failed to save configuration.");

          return;
        }

        const response = await axios.get(
          `${path_url}/journalconfiguration/usercid/${valid}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        const condata = response.data;

        setData(condata.body);

        updateStates(condata);
      } catch (error) {
        console.error("Error fetching configuration:", error);
      }
    };
    fetchConfig();
  }, []);

  const updateStates = (config) => {
    const body = config?.body?.[0];
    if (!body) {
      console.error("Body is undefined or empty");
      return;
    }
    setShowAllConfigurations(body.showAllConfigurations || false);
    setUseCrDrInsteadToDuringVoucherEntry(
      body.useCrDrInsteadToDuringVoucherEntry || false,
    );
    setPreAllocatePaymentJournalVouchers(
      body.preAllocatePaymentJournalVouchers || false,
    );
    setUseDefaultBilllWiseDetailsForBilllAllocation(
      body.useDefaultBilllWiseDetailsForBilllAllocation || false,
    );
    setShowInventoryDetails(body.showInventoryDetails || false);
    setShowBillWiseDetailsInMultipleLines(
      body.showBillWiseDetailsInMultipleLines || false,
    );
    setShowListOfBillsForSelection(body.showListOfBillsForSelection || false);
    setShowFinalBalancesForEachBill(body.showFinalBalancesForEachBill || false);
    setProvideReferenceNoAndDate(body.provideReferenceNoAndDate || false);
    setWarnOnNegativeCashBalance(body.warnOnNegativeCashBalance || false);
    setSkipDateFieldDuringVoucherCreation(
      body.skipDateFieldDuringVoucherCreation || false,
    );
    setShowCurrentBalanceOfLedgers(body.showCurrentBalanceOfLedgers || false);
    setShowBalancesAsVocherDate(body.showBalancesAsVocherDate || false);
    setShoeFinalLedgerBalance(body.shoeFinalLedgerBalance || false);
    setEnableStripeView(body.enableStripeView || false);
    setUseDefaultBankAllocations(body.useDefaultBankAllocations || false);
    setUseAutoChequeNumbering(body.useAutoChequeNumbering || false);
    setSelectChequeRange(body.selectChequeRange || false);
    setPrintChequeAfterSavingVoucher(
      body.printChequeAfterSavingVoucher || false,
    );
    setShowChequeDetailsBeforePrinting(
      body.showChequeDetailsBeforePrinting || false,
    );
    setShowBankAlloocationDetails(body.showBankAlloocationDetails || false);
    setRemoveBankDateWhileAlteringReconciledVoucher(
      body.removeBankDateWhileAlteringReconciledVoucher || false,
    );
    setProvidePartyDetailForGST(body.providePartyDetailForGST || false);
    setModifyGSTHSNSACRElatedDetails(
      body.modifyGSTHSNSACRElatedDetails || false,
    );
  };

  const checknot = (e) => {
    navigate("/crm-dashboard");
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (data.length > 0) {
      // showSuccessAlert("You want to update the data !");
      const configData = {
        id: data[0].id,
        usercid: data[0].usercid,
        adminid: data[0].useradminid,
        showAllConfigurations: showAllConfigurations,
        useCrDrInsteadToDuringVoucherEntry: useCrDrInsteadToDuringVoucherEntry,
        preAllocatePaymentJournalVouchers: preAllocatePaymentJournalVouchers,
        useDefaultBilllWiseDetailsForBilllAllocation:
          useDefaultBilllWiseDetailsForBilllAllocation,
        showInventoryDetails: showInventoryDetails,
        showBillWiseDetailsInMultipleLines: showBillWiseDetailsInMultipleLines,
        showListOfBillsForSelection: showListOfBillsForSelection,
        showFinalBalancesForEachBill: showFinalBalancesForEachBill,
        provideReferenceNoAndDate: provideReferenceNoAndDate,
        warnOnNegativeCashBalance: warnOnNegativeCashBalance,
        skipDateFieldDuringVoucherCreation: skipDateFieldDuringVoucherCreation,
        showCurrentBalanceOfLedgers: showCurrentBalanceOfLedgers,
        showBalancesAsVocherDate: showBalancesAsVocherDate,
        shoeFinalLedgerBalance: shoeFinalLedgerBalance,
        enableStripeView: enableStripeView,
        useDefaultBankAllocations: useDefaultBankAllocations,
        useAutoChequeNumbering: useAutoChequeNumbering,
        selectChequeRange: selectChequeRange,
        printChequeAfterSavingVoucher: printChequeAfterSavingVoucher,
        showChequeDetailsBeforePrinting: showChequeDetailsBeforePrinting,
        showBankAlloocationDetails: showBankAlloocationDetails,
        removeBankDateWhileAlteringReconciledVoucher:
          removeBankDateWhileAlteringReconciledVoucher,
        providePartyDetailForGST: providePartyDetailForGST,
        modifyGSTHSNSACRElatedDetails: modifyGSTHSNSACRElatedDetails,
      };
      try {
        const token = localStorage.getItem("accessToken");

        if (!token) {
          console.error("No access token found.");
          toast.error("Authorization failed. No ccess token.");
          // showSuccessAlert("Authorization failed. No access token.");
          return;
        }

        const res = await axios.post(
          `${path_url}/journalconfiguration`,
          configData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );
        toast.success("Configuration Data Saved Successfully");
      } catch (err) {
        console.error("Error occurred:", err);
        toast.error("Failed to save configuration.");
      } finally {
        setTimeout(() => {
          navigate("/crm-dashboard");
        }, 2000);
      }
    } else {
      const configData = {
        usercid: localStorage.getItem("userId"),
        useradminid: localStorage.getItem("adminId"),
        showAllConfigurations: showAllConfigurations,
        useCrDrInsteadToDuringVoucherEntry: useCrDrInsteadToDuringVoucherEntry,
        preAllocatePaymentJournalVouchers: preAllocatePaymentJournalVouchers,
        useDefaultBilllWiseDetailsForBilllAllocation:
          useDefaultBilllWiseDetailsForBilllAllocation,
        showInventoryDetails: showInventoryDetails,
        showBillWiseDetailsInMultipleLines: showBillWiseDetailsInMultipleLines,
        showListOfBillsForSelection: showListOfBillsForSelection,
        showFinalBalancesForEachBill: showFinalBalancesForEachBill,
        provideReferenceNoAndDate: provideReferenceNoAndDate,
        warnOnNegativeCashBalance: warnOnNegativeCashBalance,
        skipDateFieldDuringVoucherCreation: skipDateFieldDuringVoucherCreation,
        showCurrentBalanceOfLedgers: showCurrentBalanceOfLedgers,
        showBalancesAsVocherDate: showBalancesAsVocherDate,
        shoeFinalLedgerBalance: shoeFinalLedgerBalance,
        enableStripeView: enableStripeView,
        useDefaultBankAllocations: useDefaultBankAllocations,
        useAutoChequeNumbering: useAutoChequeNumbering,
        selectChequeRange: selectChequeRange,
        printChequeAfterSavingVoucher: printChequeAfterSavingVoucher,
        showChequeDetailsBeforePrinting: showChequeDetailsBeforePrinting,
        showBankAlloocationDetails: showBankAlloocationDetails,
        removeBankDateWhileAlteringReconciledVoucher:
          removeBankDateWhileAlteringReconciledVoucher,
        providePartyDetailForGST: providePartyDetailForGST,
        modifyGSTHSNSACRElatedDetails: modifyGSTHSNSACRElatedDetails,
      };

      try {
        const token = localStorage.getItem("accessToken");

        if (!token) {
          toast.error("Authorization failed. No access token.");
          return;
        }

        const res = await axios.post(
          `${path_url}/journalconfiguration`,
          configData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );
        toast.success("Configuration Data Saved Successfully");
      } catch (err) {
        toast.error("Failed to save configuration.");
      } finally {
        setTimeout(() => {
          navigate("/crm-dashboard");
        }, 2000);
      }
    }
  };
  // function showSuccessAlert(message) {
  //   const alertContainer = document.createElement("div");
  //   alertContainer.classList.add("success-message"); // Add a CSS class

  //   const alertText = document.createElement("p");
  //   alertText.textContent = message;

  //   alertContainer.appendChild(alertText);
  //   document.body.appendChild(alertContainer);

  //   // Optional: Set a timeout to automatically remove the alert
  //   setTimeout(() => {
  //     alertContainer.remove();
  //   }, 1500); // Adjust timeout as needed
  // }

  const handleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  return (
    <div>
      <div style={{ textAlign: "center" }}></div>
      <Modal
        disableAutoFocus={true}
        open={isModalOpen}
        onClose={handleModal}
        style={{
          overflowY: "auto",
          maxHeight: "100%",
          margin: "auto",
        }}
      >
        <div className="configuration">
          <div className="journ">
            <img
              src="/assets/crossicon.png"
              alt="icon"
              className="cross"
              onClick={handleClose}
            />
            <h1 className="firsth">Journal Configuration</h1>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="headres">
              <div className="headone">
                <h3 style={{ fontSize: "small" }}>General Details</h3>
                <div className="toggle-row">
                  <div className="divrow">
                    <label>Use Cr/Dr instead of To/By during </label>
                    <div class="xsde">
                      <img
                        src="/assets/infoicon.png"
                        alt="infoicon"
                        className="infobut"
                      />
                      <div class="tcvr">For Voucher entry</div>
                    </div>
                  </div>
                  <div className="outerbut">
                    <label class="toggle-button">
                      <input
                        type="checkbox"
                        onChange={() => {
                          setUseCrDrInsteadToDuringVoucherEntry(
                            !useCrDrInsteadToDuringVoucherEntry,
                          );
                        }}
                        value={useCrDrInsteadToDuringVoucherEntry}
                      />
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>

                <div className="toggle-row">
                  <div className="divrow">
                    <label>Preallocate Bills for Payment </label>
                    <div class="xsde">
                      <img
                        src="/assets/infoicon.png"
                        alt="infoicon"
                        className="infobut"
                      />
                      <div class="tcvr">/Receipt/Journal Vouchers</div>
                    </div>
                  </div>
                  <div className="outerbut">
                    <label class="toggle-button">
                      <input
                        type="checkbox"
                        onChange={() => {
                          setPreAllocatePaymentJournalVouchers(
                            !preAllocatePaymentJournalVouchers,
                          );
                        }}
                        value={preAllocatePaymentJournalVouchers}
                      />
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div className="toggle-row">
                  <div className="divrow">
                    <label>Use default Bill-wise details</label>
                    <div class="xsde">
                      <img
                        src="/assets/infoicon.png"
                        alt="infoicon"
                        className="infobut"
                      />
                      <div class="tcvr">
                        Use default Bill-wise detailsfor Bill Allocation
                      </div>
                    </div>
                  </div>
                  <div className="outerbut">
                    <label class="toggle-button">
                      <input
                        type="checkbox"
                        onChange={() => {
                          setUseDefaultBilllWiseDetailsForBilllAllocation(
                            !useDefaultBilllWiseDetailsForBilllAllocation,
                          );
                        }}
                        value={useDefaultBilllWiseDetailsForBilllAllocation}
                      />
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div className="toggle-row">
                  <div className="divrow">
                    <label>Show Inventory Details </label>
                    <div class="xsde">
                      <img
                        src="/assets/infoicon.png"
                        alt="infoicon"
                        className="infobut"
                      />
                      <div class="tcvr"> For Inventory checking </div>
                    </div>
                  </div>
                  <div className="outerbut">
                    <label class="toggle-button">
                      <input
                        type="checkbox"
                        onChange={() => {
                          setShowInventoryDetails(!showInventoryDetails);
                        }}
                        value={showInventoryDetails}
                      />
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div className="toggle-row">
                  <div className="divrow">
                    <label>Show Bill-wise </label>
                    <div class="xsde">
                      <img
                        src="/assets/infoicon.png"
                        alt="infoicon"
                        className="infobut"
                      />
                      <div class="tcvr">
                        Show Bill-wise For Bill-wise checking Details
                      </div>
                    </div>
                  </div>
                  <div className="outerbut">
                    <label class="toggle-button">
                      <input
                        type="checkbox"
                        onChange={() => {
                          setShowAllConfigurations(!showAllConfigurations);
                        }}
                        value={showAllConfigurations}
                      />
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div className="toggle-row">
                  <div className="divrow">
                    <label>Show Bill details </label>
                    <div class="xsde">
                      <img
                        src="/assets/infoicon.png"
                        alt="infoicon"
                        className="infobut"
                      />
                      <div class="tcvr">
                        Show Bill details wise in multiple lines
                      </div>
                    </div>
                  </div>
                  <div className="outerbut">
                    <label class="toggle-button">
                      <input
                        type="checkbox"
                        onChange={() => {
                          setShowBillWiseDetailsInMultipleLines(
                            !showBillWiseDetailsInMultipleLines,
                          );
                        }}
                        value={showBillWiseDetailsInMultipleLines}
                      />
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div className="toggle-row">
                  <div className="divrow">
                    <label>Show list Bills</label>
                    <div class="xsde">
                      <img
                        src="/assets/infoicon.png"
                        alt="infoicon"
                        className="infobut"
                      />
                      <div class="tcvr"> for selection</div>
                    </div>
                  </div>
                  <div className="outerbut">
                    <label class="toggle-button">
                      <input
                        type="checkbox"
                        onChange={() => {
                          setShowListOfBillsForSelection(
                            !showListOfBillsForSelection,
                          );
                        }}
                        value={showListOfBillsForSelection}
                      />
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div className="toggle-row">
                  <div className="divrow">
                    <label>Show Final Balances </label>
                    <div class="xsde">
                      <img
                        src="/assets/infoicon.png"
                        alt="infoicon"
                        className="infobut"
                      />
                      <div class="tcvr"> for each Bill</div>
                    </div>
                  </div>
                  <div className="outerbut">
                    <label class="toggle-button">
                      <input
                        type="checkbox"
                        onChange={() => {
                          setShowFinalBalancesForEachBill(
                            !showFinalBalancesForEachBill,
                          );
                        }}
                        value={showFinalBalancesForEachBill}
                      />
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div className="toggle-row">
                  <div className="divrow">
                    <label>Provide References </label>
                    <div class="xsde">
                      <img
                        src="/assets/infoicon.png"
                        alt="infoicon"
                        className="infobut"
                      />
                      <div class="tcvr"> No.and Date</div>
                    </div>
                  </div>
                  <div className="outerbut">
                    <label class="toggle-button">
                      <input
                        type="checkbox"
                        onChange={() => {
                          setProvideReferenceNoAndDate(
                            !provideReferenceNoAndDate,
                          );
                        }}
                        value={provideReferenceNoAndDate}
                      />
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div className="toggle-row">
                  <div className="divrow">
                    <label>Warn on negative </label>
                    <div class="xsde">
                      <img
                        src="/assets/infoicon.png"
                        alt="infoicon"
                        className="infobut"
                      />
                      <div class="tcvr"> Cash Balance</div>
                    </div>
                  </div>
                  <div className="outerbut">
                    <label class="toggle-button">
                      <input
                        type="checkbox"
                        onChange={() => {
                          setWarnOnNegativeCashBalance(
                            !warnOnNegativeCashBalance,
                          );
                        }}
                        value={warnOnNegativeCashBalance}
                      />
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div className="toggle-row">
                  <div className="divrow">
                    <label>Skip the Date </label>
                    <div class="xsde">
                      <img
                        src="/assets/infoicon.png"
                        alt="infoicon"
                        className="infobut"
                      />
                      <div class="tcvr"> field during voucher creation</div>
                    </div>
                  </div>
                  <div className="outerbut">
                    <label class="toggle-button">
                      <input
                        type="checkbox"
                        onChange={() => {
                          setSkipDateFieldDuringVoucherCreation(
                            !skipDateFieldDuringVoucherCreation,
                          );
                        }}
                        value={skipDateFieldDuringVoucherCreation}
                      />
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div className="toggle-row">
                  <div className="divrow">
                    <label>Show Curent Balance </label>
                    <div class="xsde">
                      <img
                        src="/assets/infoicon.png"
                        alt="infoicon"
                        className="infobut"
                      />
                      <div class="tcvr">of Ledgers</div>
                    </div>
                  </div>
                  <div className="outerbut">
                    <label class="toggle-button">
                      <input
                        type="checkbox"
                        onChange={() => {
                          setShowCurrentBalanceOfLedgers(
                            !showCurrentBalanceOfLedgers,
                          );
                        }}
                        value={showCurrentBalanceOfLedgers}
                      />
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div className="toggle-row">
                  <div className="divrow">
                    <label>Show Balances as </label>
                    <div class="xsde">
                      <img
                        src="/assets/infoicon.png"
                        alt="infoicon"
                        className="infobut"
                      />
                      <div class="tcvr">on Voucher date</div>
                    </div>
                  </div>
                  <div className="outerbut">
                    <label class="toggle-button">
                      <input
                        type="checkbox"
                        onChange={() => {
                          setShowBalancesAsVocherDate(
                            !showBalancesAsVocherDate,
                          );
                        }}
                        value={showBalancesAsVocherDate}
                      />
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div className="toggle-row">
                  <div className="divrow">
                    <label>Show final Ledger </label>
                    <div class="xsde">
                      <img
                        src="/assets/infoicon.png"
                        alt="infoicon"
                        className="infobut"
                      />
                      <div class="tcvr"> For Balance</div>
                    </div>
                  </div>
                  <div className="outerbut">
                    <label class="toggle-button">
                      <input
                        type="checkbox"
                        onChange={() => {
                          setShoeFinalLedgerBalance(!shoeFinalLedgerBalance);
                        }}
                        value={shoeFinalLedgerBalance}
                      />
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <div className="toggle-row">
                  <div className="divrow">
                    <label>Enable Stripe View </label>
                    <div class="xsde">
                      <img
                        src="/assets/infoicon.png"
                        alt="infoicon"
                        className="infobut"
                      />
                      <div class="tcvr">For stripe view</div>
                    </div>
                  </div>
                  <div className="outerbut">
                    <label class="toggle-button">
                      <input
                        type="checkbox"
                        onChange={() => {
                          setEnableStripeView(!enableStripeView);
                        }}
                        value={enableStripeView}
                      />
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="headcol">
                <div className="headtwo">
                  <h3 style={{ fontSize: "small" }}>Bank Details</h3>
                  <div className="toggle-row">
                    <div className="divrow">
                      <label>Use default Bank </label>
                      <div class="xsde">
                        <img
                          src="/assets/infoicon.png"
                          alt="infoicon"
                          className="infobut"
                        />
                        <div class="tcvr">For Allocation </div>
                      </div>
                    </div>
                    <div className="outerbut">
                      <label class="toggle-button">
                        <input
                          type="checkbox"
                          onChange={() => {
                            setUseDefaultBankAllocations(
                              !useDefaultBankAllocations,
                            );
                          }}
                          value={useDefaultBankAllocations}
                        />
                        <span class="slider"></span>
                      </label>
                    </div>
                  </div>
                  <div className="toggle-row">
                    <div className="divrow">
                      <label>Use Auto Cheque</label>
                      <div class="xsde">
                        <img
                          src="/assets/infoicon.png"
                          alt="infoicon"
                          className="infobut"
                        />
                        <div class="tcvr">For Numbering </div>
                      </div>
                    </div>
                    <div className="outerbut">
                      <label class="toggle-button">
                        <input
                          type="checkbox"
                          onChange={() => {
                            setUseAutoChequeNumbering(!useAutoChequeNumbering);
                          }}
                          value={useAutoChequeNumbering}
                        />
                        <span class="slider"></span>
                      </label>
                    </div>
                  </div>
                  <div className="toggle-row">
                    <div className="divrow">
                      <label>Select Cheque Range </label>
                      <div class="xsde">
                        <img
                          src="/assets/infoicon.png"
                          alt="infoicon"
                          className="infobut"
                        />
                        <div class="tcvr">For Range</div>
                      </div>
                    </div>
                    <div className="outerbut">
                      <label class="toggle-button">
                        <input
                          type="checkbox"
                          onChange={() => {
                            setSelectChequeRange(!selectChequeRange);
                          }}
                          value={selectChequeRange}
                        />
                        <span class="slider"></span>
                      </label>
                    </div>
                  </div>
                  <div className="toggle-row">
                    <div className="divrow">
                      <label>Print Cheque after </label>
                      <div class="xsde">
                        <img
                          src="/assets/infoicon.png"
                          alt="infoicon"
                          className="infobut"
                        />
                        <div class="tcvr">For saving Voucher</div>
                      </div>
                    </div>
                    <div className="outerbut">
                      <label class="toggle-button">
                        <input
                          type="checkbox"
                          onChange={() => {
                            setPrintChequeAfterSavingVoucher(
                              !printChequeAfterSavingVoucher,
                            );
                          }}
                          value={printChequeAfterSavingVoucher}
                        />
                        <span class="slider"></span>
                      </label>
                    </div>
                  </div>
                  <div className="toggle-row">
                    <div className="divrow">
                      <label>Show Cheque details </label>
                      <div class="xsde">
                        <img
                          src="/assets/infoicon.png"
                          alt="infoicon"
                          className="infobut"
                        />
                        <div class="tcvr"> For before printing</div>
                      </div>
                    </div>
                    <div className="outerbut">
                      <label class="toggle-button">
                        <input
                          type="checkbox"
                          onChange={() => {
                            setShowChequeDetailsBeforePrinting(
                              !showChequeDetailsBeforePrinting,
                            );
                          }}
                          value={showChequeDetailsBeforePrinting}
                        />
                        <span class="slider"></span>
                      </label>
                    </div>
                  </div>
                  <div className="toggle-row">
                    <div className="divrow">
                      <label>Show Bank Allocation</label>
                      <div class="xsde">
                        <img
                          src="/assets/infoicon.png"
                          alt="infoicon"
                          className="infobut"
                        />
                        <div class="tcvr">For Details </div>
                      </div>
                    </div>
                    <div className="outerbut">
                      <label class="toggle-button">
                        <input
                          type="checkbox"
                          onChange={() => {
                            setShowBankAlloocationDetails(
                              !showBankAlloocationDetails,
                            );
                          }}
                          value={showBankAlloocationDetails}
                        />
                        <span class="slider"></span>
                      </label>
                    </div>
                  </div>
                  <div className="toggle-row">
                    <div className="divrow">
                      <label>Remove Bank Date </label>
                      <div class="xsde">
                        <img
                          src="/assets/infoicon.png"
                          alt="infoicon"
                          className="infobut"
                        />
                        <div class="tcvr">
                          {" "}
                          While altering Reconciled Voucher
                        </div>
                      </div>
                    </div>
                    <div className="outerbut">
                      <label class="toggle-button">
                        <input
                          type="checkbox"
                          onChange={() => {
                            setRemoveBankDateWhileAlteringReconciledVoucher(
                              !removeBankDateWhileAlteringReconciledVoucher,
                            );
                          }}
                          value={removeBankDateWhileAlteringReconciledVoucher}
                        />
                        <span class="slider"></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="headthree" style={{ marginTop: "40px" }}>
                  <h3 style={{ fontSize: "small" }}>GST Details</h3>
                  <div className="toggle-row">
                    <div className="divrow">
                      <label>Provide Party details </label>
                      <div class="xsde">
                        <img
                          src="/assets/infoicon.png"
                          alt="infoicon"
                          className="infobut"
                        />
                        <div class="tcvr"> for GST</div>
                      </div>
                    </div>
                    <div className="outerbut">
                      <label class="toggle-button">
                        <input
                          type="checkbox"
                          onChange={() => {
                            setProvidePartyDetailForGST(
                              !providePartyDetailForGST,
                            );
                          }}
                          value={providePartyDetailForGST}
                        />
                        <span class="slider"></span>
                      </label>
                    </div>
                  </div>
                  <div className="toggle-row">
                    <div className="divrow">
                      <label>Modify GST & HSN/SAC </label>
                      <div class="xsde">
                        <img
                          src="/assets/infoicon.png"
                          alt="infoicon"
                          className="infobut"
                        />
                        <div class="tcvr"> & HSN/SAC related details</div>
                      </div>
                    </div>
                    <div className="outerbut">
                      <label class="toggle-button">
                        <input
                          type="checkbox"
                          onChange={() => {
                            setModifyGSTHSNSACRElatedDetails(
                              !modifyGSTHSNSACRElatedDetails,
                            );
                          }}
                          value={modifyGSTHSNSACRElatedDetails}
                        />
                        <span class="slider"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="lowbt">
              <button
                style={{
                  padding: "6px 10px",
                  borderRadius: "5px",
                  backgroundColor: "#ccc",
                  color: "black",
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={checknot}
              >
                Cancel
              </button>

              <button
                type="submit"
                style={{
                  padding: "6px 10px",
                  borderRadius: "5px",
                  backgroundColor: "#007bff",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </Modal>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
};
// const buttonStyle = (isPrimary) => ({
//   padding: "6px 10px",
//   borderRadius: "5px",
//   backgroundColor: isPrimary ? "#007bff" : "#ccc",
//   color: isPrimary ? "white" : "black",
//   border: "none",
//   cursor: "pointer",
// });

export default JournalConfiguration;
